import type { IdentityUser } from "./identity";

const NS = "https://flashbox.com";

const comoLista = (valor: unknown): string[] => {
  const lista = Array.isArray(valor) ? valor : valor === undefined ? [] : [valor];
  return lista.filter((r): r is string => typeof r === "string" && r.trim() !== "").map((r) => r.trim());
};

/**
 * Los roles del token. Auth0 los manda en el namespace de su audiencia; Cognito en el de Millana.
 * Se lee el array `roles` y también el singular `role`, que es el que exige la API: un token con
 * uno solo de los dos no puede dejar a la persona sin roles en la app y con acceso en la API.
 */
export function rolesFromClaims(user: IdentityUser | undefined, audience?: string): string[] {
  if (!user) return [];
  const fuentes = [
    audience ? user[`${audience}/roles`] : undefined,
    audience ? user[`${audience}/role`] : undefined,
    user[`${NS}/roles`],
    user[`${NS}/role`],
    user["roles"],
  ];
  return [...new Set(fuentes.flatMap(comoLista))];
}

/** Sin ningún rol, la persona inició sesión pero no tiene acceso: el trigger no le dio claims. */
export const hasAnyRole = (user: IdentityUser | undefined, audience?: string): boolean =>
  rolesFromClaims(user, audience).length > 0;

/**
 * Se bloquea sólo en sesiones de Cognito: ahí un dado de baja inicia sesión y recibe un token sin
 * rol. En Auth0 a un dado de baja lo frena Auth0 antes de entrar, y el ID token de un chofer no
 * siempre trae el rol (lo lleva el access token), así que bloquear ahí dejaría afuera a gente válida.
 */
export const isBlockedForNoRole = (
  provider: string | undefined,
  user: IdentityUser | undefined,
  audience?: string
): boolean => provider === "cognito" && !hasAnyRole(user, audience);
